import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal } from "../ui/Reveal";
import { Parallax } from "../ui/Parallax";
import { DownloadCTA } from "../ui/DownloadCTA";
import { Wave } from "../ui/decor";

const WINS = [
  "The dinner out you stopped feeling guilty about",
  "Meal ideas picked to fit the calories you banked",
  "Dessert, earned and on the table",
];

export function LifestyleBand() {
  return (
    <section className="relative overflow-hidden bg-cream-deep">
      {/* Melt into the cream page above and below */}
      <Wave fill="#FFF6EC" flip />

      <div className="container-x py-16 sm:py-24">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          {/* Photo — big tilted pop card */}
          <Reveal>
            <div className="relative">
              <Parallax distance={40}>
                <div className="relative -rotate-2 overflow-hidden rounded-[2rem] border-[3px] border-navy shadow-pop">
                  <img
                    src="/photos/lifestyle-food.jpg"
                    alt="A colourful, generous breakfast bowl — food you earned the room to enjoy"
                    className="aspect-[4/3] h-full w-full object-cover"
                  />
                </div>
              </Parallax>

              {/* Spend sticker slapped over the corner */}
              <motion.div
                className="absolute -bottom-5 -left-2 z-20 sm:left-4"
                animate={{ y: [0, -8, 0] }}
                transition={{ duration: 5, repeat: Infinity }}
              >
                <span className="sticker rotate-3">
                  Spent from your bank
                  <span className="num text-teal">−720 cal</span>
                </span>
              </motion.div>
            </div>
          </Reveal>

          {/* Copy */}
          <div className="text-center lg:text-left">
            <Reveal>
              <span className="sticker -rotate-2">Food you earned</span>
            </Reveal>
            <Reveal delay={1}>
              <h2 className="display mt-6 text-4xl leading-[1.06] text-navy sm:text-5xl">
                It's not a diet.
                <span className="block">
                  It's <span className="marker">food freedom</span> you earned.
                </span>
              </h2>
            </Reveal>
            <Reveal delay={2}>
              <p className="mx-auto mt-6 max-w-lg text-base leading-relaxed text-charcoal/70 sm:text-lg lg:mx-0">
                Every weigh-in fills a calorie bank you get to spend on real
                meals, real moments, no guilt attached. Snap a photo to log a
                meal in seconds, and let the app suggest dishes that fit what
                you've earned. Progress you can taste.
              </p>
            </Reveal>

            <Reveal delay={3}>
              <ul className="mx-auto mt-8 max-w-md space-y-4 text-left lg:mx-0">
                {WINS.map((w) => (
                  <li key={w} className="flex items-start gap-3">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 border-navy bg-teal-mist">
                      <Check className="h-4 w-4 text-navy" aria-hidden strokeWidth={3} />
                    </span>
                    <span className="pt-0.5 font-medium text-charcoal/80">{w}</span>
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal delay={4}>
              <div className="mt-9 flex justify-center lg:justify-start">
                <DownloadCTA source="lifestyle" showBadges={false} />
              </div>
            </Reveal>
          </div>
        </div>
      </div>

      <Wave fill="#FFF6EC" />
    </section>
  );
}
